import React from 'react';
import TourTooltip from './TourTooltip';
import TourOverlay from './TourOverlay';
import { useTourContext } from '../../contexts/TourContext';

const Tour: React.FC = () => {
    const { isActive } = useTourContext();

    // Não renderiza nada se o tour não está ativo
    if (!isActive) {
        return null;
    }

    return (
        <>
            <TourOverlay />
            <TourTooltip />
        </>
    );
};

export default Tour;
